module.exports = __webpack_public_path__ + "static/js/CubeWorker.8771c507.chunk.worker.js"